import { StoreApi } from 'zustand';

import { DoBoxDropdownStore, DropdownStateEntry } from './types';

type ZustandSet = StoreApi<DoBoxDropdownStore>['setState'];

export const handleSaveDropdownStates = (
  set: ZustandSet,
  dropdownStates: Record<string, boolean>,
) => {
  set((state) => ({
    ...state,
    dropdownStates: { ...dropdownStates },
  }));
};

export const handleRestoreDropdownStates = (
  state: DoBoxDropdownStore,
): Record<string, boolean> => {
  if (!state.isFromDoBoxPreview) {
    return {};
  }

  // Convert enhanced format back to legacy boolean format for backward compatibility
  const legacyStates: Record<string, boolean> = {};
  Object.entries(state.dropdownStates).forEach(([key, value]) => {
    if (typeof value === 'boolean') {
      legacyStates[key] = value;
    } else {
      legacyStates[key] = value.isOpen;
    }
  });

  return legacyStates;
};

export const handleResetDropdownStates = (set: ZustandSet) => {
  set((state) => ({
    ...state,
    dropdownStates: {},
    isFromDoBoxPreview: false,
  }));
};

export const handleSetFromDoBoxPreview = (
  set: ZustandSet,
  isFromDoBoxPreview: boolean,
) => {
  set((state) => ({
    ...state,
    isFromDoBoxPreview,
  }));
};

export const handleGetIsFromDoBoxPreview = (
  state: DoBoxDropdownStore,
): boolean => {
  return state.isFromDoBoxPreview;
};

export const handleSaveDropdownStatesEnhanced = (
  set: ZustandSet,
  dropdownStates: Record<string, DropdownStateEntry>,
) => {
  set((state) => ({
    ...state,
    dropdownStates: { ...dropdownStates },
  }));
};

export const handleRestoreDropdownStatesEnhanced = (
  state: DoBoxDropdownStore,
): Record<string, DropdownStateEntry> => {
  if (!state.isFromDoBoxPreview) {
    return {};
  }

  // Convert legacy format to enhanced format and return enhanced states
  const enhancedStates: Record<string, DropdownStateEntry> = {};
  Object.entries(state.dropdownStates).forEach(([key, value]) => {
    if (typeof value === 'boolean') {
      enhancedStates[key] = { isOpen: value, selectedItems: [] };
    } else {
      enhancedStates[key] = value;
    }
  });

  return enhancedStates;
};

export const handleSaveDropdownSelectedItems = (
  set: ZustandSet,
  entryId: string,
  selectedItems: string[],
) => {
  set((state) => {
    const currentEntry = state.dropdownStates[entryId];
    const newEntry: DropdownStateEntry =
      typeof currentEntry === 'boolean'
        ? { isOpen: currentEntry, selectedItems }
        : { isOpen: currentEntry?.isOpen ?? false, selectedItems };

    return {
      ...state,
      dropdownStates: {
        ...state.dropdownStates,
        [entryId]: newEntry,
      },
    };
  });
};

export const handleGetDropdownSelectedItems = (
  state: DoBoxDropdownStore,
  entryId: string,
): string[] => {
  const entry = state.dropdownStates[entryId];
  if (typeof entry === 'boolean') {
    return [];
  }
  return entry?.selectedItems ?? [];
};
